module.exports = __webpack_public_path__ + "static/media/referral_image.39c719b3.png";